import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const VoiceProPage = lazy(() => import('./pages/VoiceProPage'));
const MspAiPage = lazy(() => import('./pages/MspAiPage'));
const SecurityServicesPage = lazy(() => import('./pages/services/SecurityServicesPage'));
const HuntressPage = lazy(() => import('./pages/services/HuntressPage'));
const AcronisPage = lazy(() => import('./pages/services/AcronisPage'));
const DropsuitePage = lazy(() => import('./pages/services/DropsuitePage'));
const ArcTitanPage = lazy(() => import('./pages/services/ArcTitanPage'));
const ManagedServicesLandingPage = lazy(() => import('./pages/services/managed-it/ManagedITLandingPage'));
const ManagedConnectivityPage = lazy(() => import('./pages/services/managed-it/ManagedConnectivityPage'));
const ManagedSecurityFortinetPage = lazy(() => import('./pages/services/managed-it/ManagedSecurityFortinetPage'));
const ManagedNetworkPage = lazy(() => import('./pages/services/managed-it/ManagedNetworkPage'));
const MonitoringSupportPage = lazy(() => import('./pages/services/managed-it/MonitoringSupportPage'));
const ManagedMicrosoft365Page = lazy(() => import('./pages/services/managed-it/ManagedMicrosoft365Page'));
const PartnersPage = lazy(() => import('./pages/PartnersPage'));
const SpecialsPage = lazy(() => import('./pages/SpecialsPage'));
const ShopPage = lazy(() => import('./pages/ShopPage'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const CheckoutCompletePage = lazy(() => import('./pages/CheckoutCompletePage'));
const RoadmapPage = lazy(() => import('./pages/RoadmapPage'));
const IndustriesPage = lazy(() => import('./pages/IndustriesPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Loading component
const PageLoader = () => (
  <div className="page-loader" role="status" aria-live="polite">
    <span className="sr-only">Loading</span>
    <div className="spinner" aria-hidden="true"></div>
  </div>
);

const AppRoutes: React.FC = () => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />

        {/* Services */}
        <Route path="services" element={<ServicesPage />} />
        <Route path="services/:serviceId" element={<ServicesPage />} />
        <Route path="services/security" element={<SecurityServicesPage />} />
        <Route path="services/security/huntress" element={<HuntressPage />} />
        <Route path="services/security/acronis" element={<AcronisPage />} />
        <Route path="services/security/dropsuite" element={<DropsuitePage />} />
        <Route path="services/security/arctitan" element={<ArcTitanPage />} />

        {/* Managed Services (MSP/MSSP) */}
        <Route path="services/managed-services" element={<ManagedServicesLandingPage />} />
        <Route path="services/managed-services/connectivity" element={<ManagedConnectivityPage />} />
        <Route path="services/managed-services/security" element={<ManagedSecurityFortinetPage />} />
        <Route path="services/managed-services/network" element={<ManagedNetworkPage />} />
        <Route path="services/managed-services/monitoring" element={<MonitoringSupportPage />} />
        <Route path="services/managed-services/microsoft-365" element={<ManagedMicrosoft365Page />} />

        {/* Industries */}
        <Route path="industries" element={<IndustriesPage />} />
        <Route path="industries/:industryId" element={<IndustriesPage />} />

        {/* Products */}
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/voicepro" element={<VoiceProPage />} />
        <Route path="products/msp-ai" element={<MspAiPage />} />
        <Route path="partners" element={<PartnersPage />} />

        {/* Shop */}
        <Route path="specials" element={<SpecialsPage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="shop/:category" element={<ShopPage />} />
        <Route path="shop/product/:brandId/:productId" element={<ProductDetailPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="checkout/complete" element={<CheckoutCompletePage />} />
        <Route path="roadmap" element={<RoadmapPage />} />

        {/* Company */}
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="blog/*" element={<BlogPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </Suspense>
);

export default AppRoutes;
